import React, { createContext, useContext } from "react";
import { useSubscriptionAccess, SubscriptionAccessInfo } from "@company/hooks/useSubscriptionAccess";

/**
 * React-Context, der den Subscription-Status zentral cached.
 * Auf diese Weise wird die GraphQL-Query nur EINMAL pro App-Lifecycle ausgeführt
 * und alle Komponenten können die Info ohne zusätzliche Netzwerklast beziehen.
 */
const SubscriptionAccessContext = createContext<SubscriptionAccessInfo | undefined>(undefined);

export const SubscriptionAccessProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const accessInfo = useSubscriptionAccess();
  return (
    <SubscriptionAccessContext.Provider value={accessInfo}>
      {children}
    </SubscriptionAccessContext.Provider>
  );
};

export function useSubscriptionAccessContext(): SubscriptionAccessInfo {
  const ctx = useContext(SubscriptionAccessContext);
  if (!ctx) {
    // Fallback: sollte NIE passieren, wenn Provider korrekt gesetzt ist – liefert Dummy-Objekt
    throw new Error("useSubscriptionAccessContext must be used within <SubscriptionAccessProvider>");
  }
  return ctx;
} 